<template>
  <div class="about home">
    <div class="header d-none d-sm-block">
      <FloatingLogo></FloatingLogo>
      <div class="header-slider"></div>
    </div>

    <div class="header mobile d-xs-block d-sm-none">
      <FloatingLogo></FloatingLogo>
      <div class="header-slider"></div>
    </div>

    <div class="body">
      <div class="boxed container">
        <div class="title text-left">
          <h2>¿Qué hacemos?</h2>
        </div>
        <div class="content card-like">
          <div class="section">
            <span class="site-name">BUSCAMEAQUI.COM</span> es una plataforma digital
            diseñada para facilitar el encuentro entre los consumidores y los
            negocios / servicios que hacen vida en Venezuela.
          </div>

          <div class="section balloon violet">
            <div class="section-title">Si buscas un producto o servicio</div>
            <div class="section-content">
              Queremos que desde tu celular, o PC, conozcas todos los negocios y servicios
              cercanos a tí para que ahorres tiempo y dejes de dar vueltas.
            </div>
          </div>

          <div class="section balloon green">
            <div class="section-title">Si tienes un negocio o servicio</div>
            <div class="section-content">
              Queremos que <span class="site-name">BUSCAMEAQUI.COM</span> te sirva de vitrina
              en todo el país y así puedas aumentar tus ventas.
            </div>
          </div>

          <div class="section">
            <div class="section-title">¿Cómo lo hacemos?</div>
            <div class="section-content">
              Los negocios tienen la posibilidad de registrarse en
              <span class="site-name">BUSCAMEAQUI.COM</span> para ser publicados según
              su domicilio y categoría. Esto permite a los usuarios hacer búsquedas por
              Estado / Ciudad y categorías.
            </div>
          </div>

          <div class="section">
            <div class="section-content text-center">
              Es una manera simple, fácil y gratis <br/>
              de ponernos todos en contacto.<br/>
              Aprovechalo!
            </div>
          </div>

        </div>

      </div>
      <div class="bottom-spacer"></div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
  import Footer from "@/components/Footer";
  import FloatingLogo from "../components/FloatingLogo";
  export default {
    name: "FAQ",
    components: {
      FloatingLogo,
      Footer
    },
    data() {
      return {
        text: ``
      };
    },
    created () {
      this.routeChanged()
    },
    watch: {
      '$route': function (id) {
        this.routeChanged()
      }
    },
    methods: {
      routeChanged: function() {
        console.log("Fetching FAQ...")
        this.$store.dispatch({
          type: "action",
          actionType: this.$types.FETCH_FAQ,
          value: null
        });
      }
    }
  };
</script>

<style>

/*  .about .boxed {*/
/*    padding-top: 1rem;*/
/*  }*/



</style>
